// extracted by mini-css-extract-plugin
export default {"vertical":"CasDivider_vertical__wOHwQ","horizontal":"CasDivider_horizontal__9Gk2a"};